const deDE = {
    general: {
        next: "Weiter",
        previousSelection: "Ihre bisherige Auswahl:",
        change: "ändern",
        person: "Person",
        persons: "Personen",
        from: "von",
        to: "bis",
        reserveNow: "Jetzt reservieren",
        moreInfo: "Weitere Details angeben",
        yes: "Ja",
        no:"Nein",
        clock: "Uhr",
        date:{
            from: "Datum von",
            to: "Datum bis",
        },
        time:{
            from: "Zeit von",
            to: "Zeit bis",
        },
        inclusiveTax: "inkl. MwSt.",
        per: "Pro",
        emptyResult: "Konnte keinen {type} für die ausgewählte Ressource {resource} finden"
    },
    startPage:{
        title: "Welche Veranstaltung würden Sie gerne planen?",
        subtitle: "Bitte treffen sie eine Auswahl",
        metaTitle: "Welche Veranstaltung würden Sie gerne planen?"
    },
    personDetails: {
        title: "Wie viele Personen nehmen teil?",
        subtitle: "Bitte geben Sie eine Anzahl ein",
        metaTitle: "Wie viele Personen nehmen teil?",
        number: "Anzahl"
    },
    seatingType:{
        title: "Welche Bestuhlung möchten Sie?",
        subtitle: "Bitte treffen sie eine Auswahl",
        metaTitle: "Welche Bestuhlung möchten Sie?",
    },
    scheduleDuration:{
        title: "Wann findet Ihr Event statt ?",
        subtitle: "Bitte geben Sie Datum und Uhrzeit an ",
        metaTitle: "Wann findet Ihr Event statt ?",
        bookingBlocked: "Die Onlinebuchung von mehrtägigen Veranstaltungen wird zu Zeit noch nicht unterstützt. Bitte rufen Sie uns unter (0821) 4551260 an. Wir erstellen Ihnen gerne ein individuelles Angebot."
    },
    slotAvailability: {
        availableTitle: "Verfügbar!",
        availableSubtitle: "Reservieren Sie jetzt oder geben Sie weitere Details zu Ihrem Event an.",
        notAvailableTitle: "Belegt!",
        notAvailableSubtitle: "Zu Ihrem Wunschdatum sind wir bereits ausgebucht.",
        moreDateTitle: "Welcher Termin passt für Sie?",
        moreDateSubtitle: "Wählen Sie einen Termin aus.",
        moreDates: "weitere Termine",
        currentPrice: "Ihr aktueller Preis: *",
        priceInfo: "* unverbindlicher Preis-Vorschlag",
        vatInfo: "inkl. MwSt.",
        changeAppointment: "Termin ändern",
        showAvailability: "Freie Termine anzeigen",
        unavailableInfo: "Keinen Termin gefunden?",
        unavailableInfoText: "Nehmen Sie einfach Kontakt zu uns auf. {phoneNumber}",
        maxDepthReached: "Entschuldigung! Wir konnten keine passenden weiteren Termine finden, die Ihren Kriterien entsprechen. Bitte kontaktieren Sie uns für eine bessere Absprache",
        changeDate: "Zurück zur Datumsauswahl"
    },
    inventory:{
        title: "Welche Ausstattung benötigen Sie?",
        subtitle: "Bitte treffen Sie eine Auswahl.",
        metaTitle: "Welche Ausstattung benötigen Sie?",
    },
    services:{
        title: "Welche Service-Leistungen benötigen Sie?",
        subtitle: "Bitte treffen Sie eine Auswahl.",
        metaTitle: "Welche Service-Leistungen benötigen Sie?",
    },
    additionalInfo:{
        title: "Bitte geben Sie weitere Details an",
        subtitle: "",
        metaTitle: "Bitte geben Sie weitere Details an",
        overNightStay: "Möchten Sie ein separates Angebot für eine Übernachtung im Haus erhalten? *",
        notice: "* Daten werden an den {resourceName} mehr übermittelt.",

        otherWishTitle: "Welche Wünsche haben Sie noch?",
        otherWishSubtitle: "Optional können Sie uns eine Nachricht hinterlassen.",
        otherWishPlaceholder: "Ihre Nachricht"
    },

    checkout: {
        title: "Bitte geben Sie Ihre Daten ein:",
        subtitle: "",
        metaTitle: "Bitte geben Sie Ihre Daten ein:",
        company: "Firma",
        firstname: "Vorname",
        lastname: "Nachname",
        email:"Email",
        phone: "Telefon",
        street: "Straße",
        zip: "PLZ",
        city: "Ort",
        tosLink: "Ich habe die <a href='{url}' rel='noopener' target='_blank'>Allgemeinen Geschäftsbedingungen</a> gelesen und akzeptiere diese.",
        tos: "Ich habe die <a href='{url}'  onclick='return false' rel='noopener' target='_blank'>Allgemeinen Geschäftsbedingungen</a> gelesen und akzeptiere diese.",
        privacyTextLink: "Ich habe die <a href='{url}' rel='noopener' target='_blank'>Datenschutzbestimmungen</a> gelesen.",
        privacyText: "Ich habe die <a href='{url}'  onclick='return false' rel='noopener' target='_blank'>Datenschutzbestimmungen</a> gelesen.",
        infoText: "* unverbindlicher Preis-Vorschlag"
    },

    finish: {
        title: "Vielen Dank! <br /><br /> Wir haben Ihre Reservierung erhalten und melden uns schnellstmöglich bei Ihnen.",
        subtitle: "",
        metaTitle: "Vielen Dank! Wir haben Ihre Reservierung erhalten und melden uns schnellstmöglich bei Ihnen.",
        planNext: "Nächstes Event planen",
        anyQuestion: "Noch Fragen?",
        contactInfo: "Nehmen Sie einfach Kontakt zu uns auf. {phoneNumber}",
    },
    errors:{
        company: "Bitte geben Sie einen gültigen Firmennamen an",
        firstname: "Ups! Sieht aus, als ob Ihr Vorname Probleme hat",
        lastname: "Nachname sieht nicht gut aus",
        email: "Bitte stellen Sie sicher, dass Ihre E-Mail-Adresse gültig ist",
        phone: "Bitte geben Sie eine gültige Telefonnummer an",
        zip: "Bitte geben Sie eine gültige Postleitzahl ein",
        city: "Bitte geben Sie eine gültige Stadt an",
        street: "Bitte geben Sie eine gültige Straße ein",
        invalidEmailFormat: 'Ups! Ungültiges E-Mail-Format'
    },
    404: {
        title: "Oops! Dies ist offensichtlich nicht die Seite, nach der Sie gesucht haben.",
        subtitle: "Bitte teilen Sie uns mit, wie Sie hierher gekommen sind, und verwenden Sie einen der folgenden Links, um zum sicheren Hafen zurück zu navigieren.",
        metaTitle: "Oops! Dies ist offensichtlich nicht die Seite, nach der Sie gesucht haben.",
        home: {
            title: "Home",
            url: "/"
        },
        locaboo: {
            title: "Locaboo GmbH",
            url: "https://www.locaboo.com/"
        },
        westHouse: {
            title: "WestHouse",
            url: "#"
        },
        Kontakt: {
            title: "Kontakt",
            url: "https://www.locaboo.com/kontakt"
        }

    }
}
export default deDE;



// WEBPACK FOOTER //
// ./src/translation/de.js